














































import { Vue, Component } from 'vue-property-decorator';
import { VcClaimAssignDto } from '@/asdcom/apiproxy/apiproxy.dto';
import util from '@/lib/util';
import ClaimViewBaseComponent from './ClaimViewBaseComponent';
import { ConstantValuesItem } from '../../../../store/models/common';

@Component({})
export default class AssignClaim extends ClaimViewBaseComponent {
  loading: boolean = false;
  inputModel = new VcClaimAssignDto();
  county: number | null = null;
  counties: ConstantValuesItem[] = util.abp.constant.oKCounty.values;

  created(){
    //let lst:string = "";
      this.counties.forEach(element => {
        element.name = this.L(element.localizedName) || element.name;
        //lst += `<text name="${element.localizedName}" value="${element.name}" />\n`;
      });
      abp.log.debug({'claim-assign.vue: counties':this.counties});

  }

  onClose() {
    this.$router.push({name: "ClaimSummary"});
    this.inputModel = new VcClaimAssignDto();
  }

  onSave() {
    this.ValidateAll().then((isValid: boolean) => {
      if (isValid) {
        this.inputModel.claimNumber = this.$route.params.claimNumber;
        this.inputModel.countyName = this.getConstName("oKCounty", this.county as number);
        this.$appsvs.vcpOnlineOkStaff.assignVcClaim(this.inputModel)
          .then((res: any) => {
            this.onClose();
          })
      }
    })
  }
}
